<template>
  <div class="container-fluid mt-2">
    <h2>Script Aufgaben</h2>
    <hr/>
    <div class="row">
      <div class="col">
        <h4>Skript Kategorien</h4>
        <CTreeView @selectnode="updateList" treeid="scriptrules"/>
      </div>
      <div class="col-9">
        <div role="toolbar" class="btn-toolbar justify-content-between">
          <div class="btn-group">
            <button class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
            <button class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
          </div>
          <button id="new" @click="addScriptTask()" class="btn btn-primary">Hinzuf&uuml;gen</button>
        </div>
        <b-table class="mt-3" @row-clicked="openScript" striped hover fixed :items="rows" :fields="fields">
          <template v-slot:cell(cron)="data">
            <small>{{ data.item.cron }}</small>
          </template>
          <template v-slot:cell(action)="data">
            <font-awesome-icon @click="deleteScript(data.item.id)" icon="trash"/>
          </template>
        </b-table>
      </div>
    </div>
    <b-modal id="delScript" title="Achtung!" header-bg-variant="danger" @cancel="delname = false" @ok="deleteAccepted">
      <p>Möchten Sie wirklich das Skript <strong>({{ delname }})</strong> löschen?</p>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router'
import CTreeView from '@/components/tree/CTreeView.vue'
import scripttasks from '@/modules/scripttasks.js'

export default {
  name: 'ScriptTaskList',
  components: {
    CTreeView
  },
  data() {
    return {
      delname: false,
      rows: [],
      catid: 0,
      fields: [
        { key: 'id', label: 'Name'},
        { key: 'externalService', label: 'WebService'},
        { key: 'mcpTool', label: 'MCP Tool'},
        { key: 'cron', label: 'Geplant'},
        { key: 'lastrun', label: 'Letzer Lauf'},
        { key: 'action', label: 'Aktion'}
      ]
    }
  },
  mounted: function() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      scripttasks.list(this,this.catid,function(data) {
        self.rows = data;
      })
    },
    openScript: function(row) {
      if (this.delname && this.delname.length > 0) {
        this.$bvModal.show('delScript');
      } else {
        router.push({name: 'ScriptTaskEditor',params:{scriptid:row.id}});
      }
    },
    deleteAccepted: function() {
      var self = this;
      scripttasks.delete(this,this.delname,function() {
        self.fetchData();
        self.$bvToast.toast('Skript gelöscht.',{title:'Skripte',variant:'success'})
      })
      this.delname = false;
    },
    updateList: function(node) {
      if (node) {
        this.catid = node.id;
        this.fetchData();
      }
    },
    deleteScript: function(item) {
      console.log('delete ' + item);
      console.log(item);
      this.delname = item;
    },
    addScriptTask: function() {
      router.push({name: 'ScriptTaskEditor',params:{scriptid: 'new' }});
    }
  }
}
</script>
